import Vue from 'vue'
import VueMixpanel from 'vue-mixpanel'

Vue.use(VueMixpanel, {
  token: '1a84056f2976a36fa02c93f049b58e26'
})
